import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["coverageRadio", "commodityField", "cropGroupField"]

  switchCoverage(event) {
    const value = event.target.value
    this.commodityFieldTarget.classList.toggle("hidden", value !== "commodity")
    this.cropGroupFieldTarget.classList.toggle("hidden", value !== "crop_group")
  }
}
